import { nextIteration } from "./_nextIteration.js";
import { typeDataToArray } from "./_typeDataToArray.js";
export const partition = async (source, predicate) => {
    const dataFunc = nextIteration(source, (value) => {
        return [predicate(value), value];
    });
    const values = await typeDataToArray(dataFunc);
    const fail = [];
    const pass = [];
    for (const [passed, value] of values) {
        if (passed) {
            pass.push(value);
        }
        else {
            fail.push(value);
        }
    }
    return [pass, fail];
};
